module.exports = __webpack_public_path__ + "flyer_background_sparkler_two_035-0dd91fd74268f7ac7ba8e919270fae6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_sparkler_two_035.jpg
// module id = 1690
// module chunks = 1